import { styles } from "./ReportCardRisk.style";

export interface ReportCardRiskProps {
  text: string;
}

export const ReportCardRisk = (props: ReportCardRiskProps) => {
  const { text } = props;

  return <div className={styles.risk()}>{text}</div>;
};
